import { InlineText3 } from '@cian/ui-kit/typography';
import { IconFunctionalSuccess16 } from '@cian/ui-kit-design-tokens/icons';

import * as React from 'react';

import * as styles from './RosreestrVerified.css';

export const RosreestrVerified: React.FC = () => {
  return (
    <div className={styles['container']}>
      <div className={styles['success-icon-wrapper']}>
        <IconFunctionalSuccess16 color="icon-main-default" display="inline-block" />
      </div>
      <div className={styles['text-wrapper']}>
        <InlineText3 color="black_60">Проверено в&nbsp;Росреестре</InlineText3>
      </div>
    </div>
  );
};

RosreestrVerified.displayName = 'RosreestrVerified';
